import { Theme } from "@mui/material/styles";
import { CustomTheme } from "enums/customTheme";
import { RootState, useSelector } from "redux/store";
// ----------------------------------------------------------------------

export default function Tabs(theme: Theme) {
  const customTheme = useSelector(
    (state: RootState) => state.supplier.supplier?.customTheme,
  );

  const getIndicatorColor = () => {
    if (customTheme === CustomTheme.Sage) return theme.palette.sage_green;
    if (customTheme === CustomTheme.Volotea) return theme.palette.volotea.red;
    return theme.palette.secondary.main;
  };

  const getTabColor = (isActive?: boolean) => {
    if (customTheme === CustomTheme.Volotea) return theme.palette.volotea.brown;
    return isActive ? theme.palette.secondary.main : theme.palette.text.label;
  };

  return {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: getIndicatorColor(),
          height: 4,
        },
        paddimg: "2px",
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          fontWeight: theme.typography.body2,
          fontSize: 13,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          color: getTabColor(),
          "&.Mui-selected": {
            color: getTabColor(true),
            fontWeight: theme.typography.fontWeightBold,
          },
          "&:not(:last-of-type)": {
            marginRight: theme.spacing(2),
          },
          "@media (min-width: 600px)": {
            minWidth: 48,
          },
        },
        labelIcon: {
          minHeight: 32,
          flexDirection: "row",
          "& > *:first-of-type": {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
          flexDirection: "row",
          whiteSpace: "nowrap",
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: "50%",
        },
      },
    },
  };
}
